import { render } from "./SeaBackground.vue?vue&type=template&id=0f758ade&scoped=true"
import script from "./SeaBackground.vue?vue&type=script&lang=js"
export * from "./SeaBackground.vue?vue&type=script&lang=js"

import "./SeaBackground.vue?vue&type=style&index=0&id=0f758ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f758ade"]])

export default __exports__